"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPriceDropAlertUserDto = instanceOfPriceDropAlertUserDto;
exports.PriceDropAlertUserDtoFromJSON = PriceDropAlertUserDtoFromJSON;
exports.PriceDropAlertUserDtoFromJSONTyped = PriceDropAlertUserDtoFromJSONTyped;
exports.PriceDropAlertUserDtoToJSON = PriceDropAlertUserDtoToJSON;
exports.PriceDropAlertUserDtoToJSONTyped = PriceDropAlertUserDtoToJSONTyped;
/**
 * Check if a given object implements the PriceDropAlertUserDto interface.
 */
function instanceOfPriceDropAlertUserDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('fullName' in value) || value['fullName'] === undefined)
        return false;
    if (!('isVerified' in value) || value['isVerified'] === undefined)
        return false;
    return true;
}
function PriceDropAlertUserDtoFromJSON(json) {
    return PriceDropAlertUserDtoFromJSONTyped(json, false);
}
function PriceDropAlertUserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'],
        'fullName': json['fullName'],
        'isVerified': json['isVerified'],
    };
}
function PriceDropAlertUserDtoToJSON(json) {
    return PriceDropAlertUserDtoToJSONTyped(json, false);
}
function PriceDropAlertUserDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'email': value['email'],
        'fullName': value['fullName'],
        'isVerified': value['isVerified'],
    };
}
